import React, { useCallback, useRef } from 'react';
import JoditEditor from 'jodit-react';
import './JoditEditor.scss';
import { useResponsive } from '../../hooks/useResponsive';

const CustomJoditEditor = ({
  onChange,
  value,
  onFocus,
  onBlur,
  readOnly = false,
  //   height = '500px',
  className = "",
  style = {},
  backgroundColor = "#ffffff",
  autoFocus = false,
}) => {
  const isMobile = useResponsive("down", "md");
  const config = {
    readonly: readOnly,
    // height: height,
    statusbar: false,
    buttons: [
      "bold",
      "italic",
      "underline",
      "|",
      "ul",
      "ol",
      ...(isMobile ? [] : ["|", "outdent", "indent"]),
      "|",
      "image",
      ...(isMobile ? [] : ["|", "left", "center", "right"]),
    ],
    removeButtons: ["fullsize", "about"],
    showXPathInStatusbar: false,
    showCharsCounter: false,
    showWordsCounter: false,
    toolbarAdaptive: false,
    toolbarSticky: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    placeholder: "Start typing...",
    enableDragAndDropFileToEditor: true,
    autofocus: autoFocus,
    cursorAfterAutofocus: "end", // 'end';
    tabIndex: 0,
    enter: "P",
    enterBlock: "P",
    defaultMode: 1,
    useSplitMode: true,
    spellcheck: true,
    editorCssClass: "custom-editor",
    style: {
      background: backgroundColor,
    },
    controls: {
      ul: {
        list: {
          default: "Default",
          circle: "Circle",
          disc: "Disc",
          square: "Square",
        },
      },
      ol: {
        list: {
          default: "Default",
          "lower-alpha": "Lower Alpha",
          "lower-roman": "Lower Roman",
          "upper-alpha": "Upper Alpha",
          "upper-roman": "Upper Roman",
        },
      },
    },
    indentMargin: 10,
    listMargin: 10,
    uploader: {
      insertImageAsBase64URI: true,
      // url: true,
    },

    ...style,
  };

  const handleChange = useCallback(
    (newContent) => {
      // if (onChange) {
      onChange(newContent);
      // }
    },
    [onChange]
  );

  console.log("description-set re rendering ----------------------------");

  return (
    <div
      className={`jodit-editor-container ${className} ${
        readOnly ? "readonly" : ""
      }`}
    >
      <JoditEditor
        // ref={editorRef}
        value={value}
        config={config}
        // onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        tabIndex={0}
      />
    </div>
  );
};

export default React.memo(CustomJoditEditor); 